<style lang="scss" scoped>
  .password-strength-wrapper {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .password-strength-section {
      padding-right: 5px;
      flex: 1;
      font-size: 12px;
      color: #5F5F5F;
      .password-strength-bar {
        height: 5px;
        border-radius: 2px;
        background-color: $neutral-light;
        transition: background-color 0.5s ease;
        &.password-weak {
          background-color: $error;
        }
        &.password-med {
          background-color: $warning;
        }
        &.password-strong {
          background-color: $success;
        }
      }
    }
  }
</style>

<template>
  <div class="password-strength-wrapper">
    <div class="password-strength-section">
      <div class="password-strength-bar" v-bind:class="{'password-weak': weakRating}">
      </div>
    </div>
    <div class="password-strength-section">
      <div class="password-strength-bar" v-bind:class="{'password-med': mediumRating}">
      </div>
    </div>
    <div class="password-strength-section">
      <div class="password-strength-bar" v-bind:class="{'password-strong': strongRating}">
      </div>
    </div>
    <div class="password-strength-section">
      {{ ratingMessage }}
    </div>
  </div>
</template>

<script>

export default {
  name: 'PasswordStrength',
  props: ['password'],
  computed: {
    ratingMessage: function () {
      if (!this.weakRating) {
        return this.$t('tooWeak')
      }
      if (!this.mediumRating) {
        return this.$t('tooWeak')
      }
      if (!this.strongRating) {
        return this.$t('averageStrength')
      }
      return this.$t('strongPassword')
    },
    weakRating: function () {
      return this.password.length > 1
    },
    mediumRating: function () {
      let mediumTest = new RegExp('^((?=.*[A-Z])(?=.*[0-9])|(?=.*[A-Z])(?=.*[!@#$%^&*])|(?=.*[!@#$%^&*])(?=.*[0-9]))(?=.{6,})')
      return mediumTest.test(this.password)
    },
    strongRating: function () {
      let strongTest = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})')
      return strongTest.test(this.password)
    }
  }
}
</script>
